import axios from "../config/axios";
import config from "../config/index";

const McpTooling = {
    getMcpTools: (workspace_id) => {
        return axios
            .get(`${config.apiBaseURL2}mcp-tools?workspace_id=${workspace_id}`)
            .then((resp) => {
                return resp.data;
            })
            .catch((err) => console.log(err));
    },
    saveMcpTool: (params) => {
        return axios
            .post(`${config.apiBaseURL2}mcp-tools`, params)
            .then((resp) => {
                return resp.data;
            })
            .catch((err) => console.log(err));
    },
    editMcpTool: (params) => {
        return axios
            .patch(`${config.apiBaseURL2}mcp-tools/${params.id}`, params)
            .then((resp) => {
                return resp.data;
            })
            .catch((err) => console.log(err));
    },
    deleteMcpTool: (id) => {
        return axios
            .delete(`${config.apiBaseURL2}mcp-tools/${id}`)
            .then((resp) => {
                return resp.data;
            })
            .catch((err) => console.log(err));
    },
}

export default McpTooling;
